module.exports = __webpack_public_path__ + "static/media/g.93b02be8.gif";